export const variables = {
  white: '#ffffff',
  black: '#000000',
  grayDarker: '#222222',
  grayDark: '#333333',
  gray: '#555555',
  grayMedium: '#808080',
  grayLight: '#aaaaaa',
  grayLighter: '#eeeeee',
  grayLightest: '#f6f6f6',
  gray85: '#d9d9d9',
  grayLightShade: '#d5d5d5',
  brandCBP: '#003e65',
  brandPrimary: '#00416a',
  brandSuccess: '#008000',
  brandInfo: '#1460aa',
  brandWarning: '#f09511',
  brandDanger: '#a00000',
  aLink: '#0000EE',
  statePrimaryBg: '#ECF1F4',
  stateSuccessBg: '#ECF5EC',
  stateInfoBg: '#EDF3F9',
  stateWarningBg: '#FEF7ED',
  stateDangerBg: '#F8ECEC',
  borderCBP: '#003b60',
  borderAppHeader: '#e7e7e7',

  tabBorder: '3px solid #d9d9d9',
  cardBorder: '2px solid #eeeeee',
  thinCardBorder: '0.5px solid #eeeeee',
  cardBorderRadius: '4px',
  basicBorder: '1.5px solid #808080',

  fontFamily: 'Roboto, Calibri, Tahoma, Arial, san-serif',
  bodyFontSize: '1.3rem',

  link: {
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
  },

  activeLink: {
    borderBottomStyle: 'solid',
    borderBottomWidth: '2px',
  },

  childrenMarginLeft: {
    '& > *+*': {
      marginLeft: '0.5rem',
    },
  },
  childrenMarginLeft2X: {
    '& > *+*': {
      marginLeft: '1rem',
    },
  },
  childrenMarginLeft10X: {
    '& > *+*': {
      marginLeft: '5rem',
    },
  },

  childrenMarginTop: {
    '& > *+*': {
      marginTop: '0.5rem',
    },
  },
  childrenMarginTop2x: {
    '& > *+*': {
      marginTop: '1rem',
    },
  },
  childrenMarginTop8X: {
    '& > *+*': {
      marginTop: '4rem',
    },
  },
  childrenBorderTop: {
    '& > *+*': {
      borderTop: '1.5px solid #808080',
    },
  },

  spacing: (a: number) => a * 8,
};
